import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import LocaleStrings from "Languages";
import {
  fetchTopSessionTableData,
  fetchQnaInshtSessTableData,
  fetchSessionMostsearkeysTableData,
} from "SessionanalyticActions";
import { screenHeightLeftFromTop } from "Constants";
import AnalyticsCommonHeader from "AnalyticscommonAnalyticscommon";
import SessionAnalyticMenuIcon from "./session-menu-icon";
import TableContentTopSession from "./table-content-top-session";
import TableContentQnqinsights from "./table-content-qna-insights";
import TableContentMostsearchSession from "./table-content-mostsearch-session";
import TableContentSessionScanningList from "./table-content-session-scanning-attendee-list";
import TableContentSessionRSVPList from "./table-content-session-rsvp-user-list";

import { sessionsesslistviewcount } from "SessionanalyticSessviewAction";
import { sessionsessfavocount } from "SessionanalyticSessfavoAction";
import { sessionListCount } from "SessionanalyticSesslistAction";
// sessionTotalSesssearch
var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class SessionInside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      sessionQrLoader: true,
      desc: LocaleStrings.analytics_text_preparing_analytics,
    };
  }

  //
  componentDidMount() {
    // Call Top Session Table data list
    this.props.fetchTopSessionTableData(
      this.props.session,
      (fetchTopSessionTableDataResponce) => {}
    );

    // Call Top Session Table data list
    this.props.fetchQnaInshtSessTableData(
      this.props.session,
      (fetchQnaInshtSessTableDataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call Top Session Table data list
    this.props.fetchSessionMostsearkeysTableData(
      this.props.session,
      (fetchsessionmostsearkeystabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    this.props.sessionsesslistviewcount(
      this.props.session,
      (sessionsesslistviewresponse) => {
        if (sessionsesslistviewresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    // Call to Session List
    this.props.sessionListCount(
      this.props.session,
      (sessionlistcountResponse) => {
        if (sessionlistcountResponse.error === 0) {
        }
      }
    );

    this.props.sessionsessfavocount(
      this.props.session,
      (sessionsessfavoresponse) => {
        if (sessionsessfavoresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  // Arrow function for render Speaker Insights menu divs
  renderSessionanalyticMenuIcons() {
    return _.map(this.props.sessionAnalyticMenu, (sessionanalyticmenuItem) => {
      return (
        <SessionAnalyticMenuIcon
          menu={sessionanalyticmenuItem}
          key={sessionanalyticmenuItem.key}
        />
      );
    });
  }

  // Rerender All componets on this page
  mainCallback = () => {
    this.setState({ loading: true });

    // Call Top Session Table data list
    this.props.fetchTopSessionTableData(
      this.props.session,
      (fetchTopSessionTableDataResponce) => {}
    );

    // Call Top Session Table data list
    this.props.fetchQnaInshtSessTableData(
      this.props.session,
      (fetchQnaInshtSessTableDataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call Top Session Table data list
    this.props.fetchSessionMostsearkeysTableData(
      this.props.session,
      (fetchsessionmostsearkeystabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    this.props.sessionsesslistviewcount(
      this.props.session,
      (sessionsesslistviewresponse) => {
        if (sessionsesslistviewresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    // Call to Session List
    this.props.sessionListCount(
      this.props.session,
      (sessionlistcountResponse) => {
        if (sessionlistcountResponse.error === 0) {
        }
      }
    );

    this.props.sessionsessfavocount(
      this.props.session,
      (sessionsessfavoresponse) => {
        if (sessionsessfavoresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );
  };

  render() {
    let { deviceSize } = this.props;

    return (
      <div className="panel noborder-panel">
        {/* Header section */}
        {!this.state.loading ? (
          <AnalyticsCommonHeader
            finishOperationsCallback={this.mainCallback}
            callFrom="session"
          />
        ) : (
          ""
        )}

        <div
          className="panel-body scrollable-content"
          style={{
            height: deviceSize.height - screenHeightLeftFromTop,
          }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <div>
              <ul className="nav nav-pills dashboardNavPill">
                {this.renderSessionanalyticMenuIcons()}
              </ul>
              {<div className="mt-20"></div>}
              <div className="panel-body ">
                <TableContentTopSession />
                <TableContentQnqinsights />
                <TableContentMostsearchSession />

                {/* Admin Panel Session Scanning Analytics / Attendence export */}
                <TableContentSessionScanningList />
                <div style={{ height: "54px" }}></div>
                {/* Admin Panel  RSVP user list section in the session analytics screen */}
                <TableContentSessionRSVPList />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, sessionAnalyticMenu, SessionSelectedItem } = state;

  var sessiontosesstablelist = state.sessionTosessTablelist
    ? state.sessionTosessTablelist
    : [];
  var sessionQnqinsightsTablelist = state.sessionQnqinsightsTablelist
    ? state.sessionQnqinsightsTablelist
    : [];
  var totalsesslist = state.sessionAnalyticTotalSesslist
    ? state.sessionAnalyticTotalSesslist
    : [];
  var totalsessfavo = state.sessionAnalyticTotalSessfavo
    ? state.sessionAnalyticTotalSessfavo
    : [];
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    sessionAnalyticMenu,
    SessionSelectedItem,
    totalsesslist,
    totalsessfavo,
    sessiontosesstablelist,
    sessionQnqinsightsTablelist,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  sessionsesslistviewcount,
  sessionsessfavocount,
  fetchTopSessionTableData,
  fetchQnaInshtSessTableData,
  sessionListCount,
  fetchSessionMostsearkeysTableData,
})(SessionInside);
